export default "__VITE_ASSET__BjzyHiNO__"